import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {SectionWrapper} from './style'
import {KitImage} from './KitsSectionImage'
import {KitDesc} from './KitsSectionDescription'

export const HeroSection = ({section}) =>  {
    return (
        <>
            <SectionWrapper imgID={section.id} bgColor={section.bgColor} wrapped={section.wrapped} img_first={section.img_first}>                
                <Container fluid>
                    <Row xs={1} md={2}>
                        <Col sm={{order: section.img_first ? 1 : 2}} lg={7}><KitImage imgID={section.id}/></Col>
                        <Col sm={{order: section.img_first ? 2 : 1}} lg={5}><KitDesc title={section.title} desc={section.description} button={section.button}/></Col>
                    </Row>
                </Container>
            </SectionWrapper>
        </>
    )
}
